// extracted by mini-css-extract-plugin
export var standaloneTable = "_gk-0";
export var withExtraHeader = "_gk-1";